<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Solicitud de Evaluación por Bloque</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-4 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
                <div class="container-fluid">
                  <label class="label-black">Archivo de Excel</label>
                  <div class="form-group">
                    <input type="file" @change="uploadFile" ref="file" id="archivoaSubir" class="form-control">
                  </div>
                  <div class="form-group">
                    <label class="label-black">Fecha límite de Evaluación</label>
                    <input type="date" class="form-control" id="fechaLimite" v-model="FechaLimite" />
                  </div>
                  <div class="form-group">
                    <button @click="submitFile" class="btn btn-sm btn-custom">Crear Solicitud</button>
                  </div>
                </div>
        </div>
      </div>
    </div>

    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>
    
    <!-- <br>
    <div slot="main" class="col-12 col-sm-12 col-md-12 col-lg-4">
      <div class="area">
        <div class="container-fluid">
          <label>Archivo de Excel</label>
          <div class="form-group">
            <input type="file" @change="uploadFile" ref="file" id="archivoaSubir" class="form-control">
          </div>
          <div class="form-group">
            <label>Fecha límite de Evaluación</label>
            <input type="date" class="form-control" id="fechaLimite" v-model="FechaLimite" />
          </div>
          <div class="form-group">
            <button @click="submitFile" class="btn btn-light">Crear Solicitud</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import catalogos from '@/../static/js/catalogos'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import axios from 'axios'
import Vue from 'vue'
import store from '@/store/index'

export default {
  data() {
    return {
      ArchivoExcel: null,
      FechaLimite: null,
    }
  },
  components: {
    //Layout
    ModalConfirmacion: catalogos.SIAP.ModalConfirmacion
  },
  methods: {
    uploadFile() {
      this.ArchivoExcel = this.$refs.file.files[0];
    },
    submitFile() {
      comun.SeEstaCargandoInformacion(true);
      var datosDelFormulario = new FormData();
      datosDelFormulario.append("Archivo", this.ArchivoExcel);
      datosDelFormulario.append("fechaLimite", this.FechaLimite);
      axios.post(api.conexion + api.SISEVA.funcion.SolicitudPorBloque, datosDelFormulario,
        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
      ).then(respuesta => {
        if (respuesta.data.SiHayError) {
          this.ArchivoExcel = null;
          $("#archivoaSubir").val('');
          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
        } else {
          this.ArchivoExcel = null;
          $("#archivoaSubir").val('');
          comun.SeEstaCargandoInformacion(false);
          this.$router.push("/SIAP/SolicitudesEvaluacion")
        }
        comun.SeEstaCargandoInformacion(false);
      }
      ).catch(excepcion => {
        console.log(excepcion);
        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
        comun.SeEstaCargandoInformacion(false);
      });
      comun.SeEstaCargandoInformacion(false);
    }
  }, beforeMount: function () {
  }
}

</script>

<style scoped>
#cuerpoModalDetalles {
  overflow-y: auto;
  max-height: 400px;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/NuevaSolicitudBloque.vue